import React from 'react'
import {Input} from 'components/common'
import {SimpleBanner} from './banner'
import FeedComponent, { Feed } from './feed-component'
import AdvertisementView from './advertisement-view'
import { User } from './user'

export default class FeedPage extends React.Component {
	constructor(props) {
		super(props)
		this.state = {
			feed_id: 0,
			feed: null,
			f_term: null
		};
		this.componentWillReceiveProps(props)
	}

	componentWillReceiveProps(props) {
		this.state.feed_id = props.match && props.match.params.fid
			? props.match.params.fid
			: 0;
		if (this.state.feed_id) {
			http.get('/home/getFeed.json', {feed_id: this.state.feed_id}, response => {
				let feed = response.feed.length > 0 ? response.feed[0] : null;
				if (feed) {
					feed.updated_at = new Date(feed.updated_at)
					User.merge(response.profiles);
				}
				this.setState({feed: feed});
			})
		}
		else {
			this.state.feed_id = 0;
			this.state.feed = null;
		}
	}

	filter() {
		this.forceUpdate();
	}

	onFilterKeyDown(e) {
		if (!e.ctrlKey && !e.shiftKey && e.keyCode == 13) {
			this.forceUpdate();
		}
	}

	render() {
		if (this.state.feed) {
			return (
				<div>
					<SimpleBanner title={__('socials_partner_pubs')} />
					<div className="container-fluid">
						<div className="row feed feed-one justify-content-center mt-4">
							<div className="col-sm-12 col-lg-6">
								<Feed feed={this.state.feed} showDetails={true} />
							</div>
							<div className="col-sm-12 col-md-2 advertisement">
								<h6>{__('socials_advertisement')}</h6>
								<div className="row no-gutters advertisement">
									<AdvertisementView alias="advertisement-feed-detail" random={1} />
								</div>
							</div>
						</div>
					</div>
				</div>
			)
		}
		if (this.state.feed_id) {
			return null;
		}
		return (
			<div className="news">
				<SimpleBanner title={__('socials_partner_pubs')} />
				<div className="container-fluid">
					<div className="row mx-0">
						<div className="col-sm-12 col-md-10">
							<div className="float-right">
								<div className="input-group input-group-sm mt-3">
									<div className="input-group input-group-sm mb-3">
										<Input model={this.state} name="f_term" placeholder={__('attrs_search')} onKeyDown={this.onFilterKeyDown.bind(this)} />
										<div className="input-group-append">
											<button className="btn btn-secondary" onClick={this.filter.bind(this)}>
												<em className="la la-search" />
											</button>
											{this.state.f_term
											 ? <button className="btn btn-light" onClick={() => this.setState({f_term: null})}>
												<em className="la la-times" />
											   </button>
											 : null}
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>

					<div className="row justify-content-center">
						<div className="col-sm-12 col-md-10">
							<FeedComponent pagination={true} filter={this.state.f_term} />
						</div>
						<div className="col-sm-12 col-md-2 mt-2 advertisement">
							<h6>{__('socials_advertisement')}</h6>
							<div className="row no-gutters advertisement">
								<AdvertisementView alias="advertisement-feed" random={1} />
							</div>
						</div>
					</div>
				</div>
			</div>
		);
	}
}
